import Scene from "~/scene";
import CadastralLookupbox from "~/util/providers/lookupbox/cadastral";
import FotoWcamLookupbox from "~/util/providers/lookupbox/foto-wcam";
import PoiaggLookupbox from "~/util/providers/lookupbox/poiagg";
import SceneLayerTraffic from "./scene/layer/traffic";
import SceneLayerWinter from "./scene/layer/winter";

interface IPoiserverItem {
	poiserver: string;
	lookupBoxClass: CadastralLookupbox | FotoWcamLookupbox | PoiaggLookupbox;
	opts: any;
}

export default class DataProvider {
	_active: boolean;

	_poiservers: Array<IPoiserverItem> = [];

	_layers: Array<any>;

	_trafficLayer: SceneLayerTraffic;

	_winterLayer: SceneLayerWinter;

	_responses: Array<any>;

	_remainingCount: number;

	_requestForMapProvider: boolean;

	constructor() {
		this._active = false;
		this._layers = [];
		this._trafficLayer = null;
		this._winterLayer = null;
		this._poiservers = [];
		this._responses = [];
		// poiserveru se jeste nevyslovilo
		this._remainingCount = 0;
		this._requestForMapProvider = false;
	}

	isActive() {
		return this._active;
	}

	enable() {
		if (this._active) {
			return null;
		}
		this._active = true;
		this._layers.forEach(layer => layer.enable());

		this._request(false);

		return this;
	}

	disable() {
		if (!this._active) {
			return null;
		}

		this._active = false;
		this._layers.forEach(layer => layer.disable());

		return this;
	}

	/**
	 * Další poiserver, kterému budeme říkat o lookup
	 */
	addPOIServer(data: IPoiserverItem) {
		if (this._poiservers.filter(item => item.poiserver === data.poiserver).length > 0) {
			return this;
		}

		this._poiservers.push(data);

		return this;
	}

	updatePOIServer(data: IPoiserverItem) {
		const filtered = this._poiservers.filter(item => item.poiserver === data.poiserver);

		if (filtered.length === 1) {
			filtered[0].opts = data.opts;
		}

		return this;
	}

	removePOIServer(poiserver: IPoiserverItem["poiserver"]) {
		const index = this._poiservers.findIndex(item => item.poiserver === poiserver);

		if (index < 0) {
			return null;
		}

		const removed = this._poiservers.splice(index, 1);

		return removed[0];
	}

	clearPOIServers() {
		this._poiservers.length = 0;

		return this;
	}

	/**
	 *  Pro nektere scanere (napr. fotomapy) si vynucuju lookupy i kdyz nedojde
	 * k prekresleni mapy
	 */
	forceRequest(full) {
		this._request(full);
	}

	/**
	 * Další vrstva, kterou budeme plnit.
	 * FIXME asi bychom meli mit jen jednu.
	 */
	addLayer(layer) {
		this._layers.push(layer);

		return this;
	}

	addTrafficLayer(trafficLayer) {
		this._trafficLayer = trafficLayer;
	}

	addWinterLayer(winterLayer) {
		this._winterLayer = winterLayer;
	}

	/**
	 * Překreslení mapy => dotaz na poiservery
	 * @param {bool} full Plne prekresleni? Pokud ano, schovame soucasne poie, aby neuskocily
	 */
	_request(full?: boolean) {
		if (!this._active) {
			return;
		}

		this._responses = [];

		// zadne typy ani mapova sada, potazmo zadne poiservery
		if (!this._poiservers.length) {
			this._layers.forEach(layer => layer.removeAll());

			return;
		}

		// bylo plne prekresleni, tak rychle vsechno schovame, at to pri odpovedi z poiserveru neposkoci
		if (full) {
			this._clear();
		}

		// nastavit citac requestu
		this._remainingCount = 0;
		// pro koho se deje request?
		this._requestForMapProvider = Scene.isMapActive();

		// obejit poiservery
		this._poiservers.forEach(async poiserver => {
			this._remainingCount++;

			try {
				const data = await poiserver.lookupBoxClass.lookupbox();

				this._responsePoiserver(data);
			} catch (exc) {
				//console.log(exc);
			}
		});
	}

	_clear() {
		this._layers.forEach(layer => layer.clear());

		if (this._trafficLayer) {
			this._trafficLayer.clear();
		}

		if (this._winterLayer) {
			this._winterLayer.clear();
		}
	}

	/**
	 * Odpověď z poiserveru
	 */
	_responsePoiserver(data) {
		this._remainingCount--;
		this._responses.push(data);

		if (!this._remainingCount) {
			this._done();
		}
	}

	/**
	 * Máme všechny odpovědi, obejdeme vrstvy
	 */
	_done() {
		const test = this._requestForMapProvider === Scene.isMapActive();

		if (test) {
			this._layers.forEach(layer => {
				layer.fillFromData(JSON.parse(JSON.stringify(this._responses)));
			});

			if (this._trafficLayer) {
				this._trafficLayer.fillFromData(JSON.parse(JSON.stringify(this._responses)));
			}

			if (this._winterLayer) {
				this._winterLayer.fillFromData(JSON.parse(JSON.stringify(this._responses)));
			}
		}

		this._responses.length = 0;

		if (test) {
			Scene.makeEvent("markers-ready");
		}
	}
}
